import { AutoSizer, Index, List as VitualizedList } from "@logicsoftware/react-virtualized";
import * as React from "react";
import { CustomScrollBarWrapper } from "../customScrollBarWrapper/CustomScrollBarWrapper";
import { virtualListStyleFix } from "../index";
import { BaseList, InternalListProps, MandatoryCommonListProps } from "./BaseList";
import { ListBaseProps } from "./List";
import { getListHeightImp } from "./utils/listUtils";

type VirtListProps<ItemType> = InternalListProps<ItemType> &
    MandatoryCommonListProps &
    Pick<ListBaseProps<ItemType>, "getItemHeight">;

export class VirtList<ItemType> extends BaseList<ItemType, VirtListProps<ItemType>, any> {
    listRef: React.RefObject<VitualizedList> = React.createRef();

    getItemHeight = ({ index }: Index) => {
        const { getItemHeight, items } = this.props;
        return getItemHeight(items[index], index, items);
    };

    renderList(width: number) {
        const {
            items,
            itemHeight,
            focusedItem,
            getItemHeight,
            searchText,
            height,
            getItemLabel,
            customScrollbar,
            onSelect,
            setFocusedItem,
            listRowComponent,
            listWidth,
            getItemClassName,
            ...passThroughProps
        } = this.props;

        const focusedIndex = items.indexOf(focusedItem);
        const listHeight = getListHeightImp(items, itemHeight, getItemHeight, height);
        const customStyle = { height: "auto" };

        const returnList = () => (
            <VitualizedList
                ref={this.listRef}
                width={width}
                height={listHeight}
                rowCount={items.length}
                rowHeight={getItemHeight ? this.getItemHeight : itemHeight}
                rowRenderer={this.rowRenderer}
                scrollToIndex={focusedIndex}
                currentFocusedItem={focusedItem}
                currentSearchText={searchText}
                tabIndex={null}
                style={customScrollbar ? { ...virtualListStyleFix, ...customStyle } : virtualListStyleFix}
                items={items}
                role={"listbox"}
                {...passThroughProps}
            />
        );

        return customScrollbar ? (
            <CustomScrollBarWrapper ref={this.listRef} style={{ width, height: listHeight }}>
                {returnList()}
            </CustomScrollBarWrapper>
        ) : (
            returnList()
        );
    }

    render() {
        return !this.props.listWidth ? (
            <AutoSizer disableHeight={true}>{({ width }) => this.renderList(width)}</AutoSizer>
        ) : (
            this.renderList(this.props.listWidth)
        );
    }

    invalidateRowsHeight() {
        this.listRef.current?.recomputeGridSize();
    }
}
